<template>
  <div>
    <vx-card
      title="Фильтры"
      class="p-1 mb-3 passes__filter-card"
      style="background: #e3e6fd"
      collapseAction
    >
      <div class="flex flex-wrap items-center justify-start w-full">
        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="getAccounts()"
            :options="countItemsOmPage"
            :clearable="false"
            style="background-color: #fff"
            v-model="countElements"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="filterAccounts"
            label="name"
            :options="countyType"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filter.home__county_type"
            placeholder="Выбор поселения"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="ФИО"
            v-model="filter.user__full_name"
          />
        </div>
        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="Номер участка"
            v-model="filter.home__homestead_number"
          />
        </div>
        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="Лицевой счет"
            v-model="filter.account__icontains"
          />
        </div>
      </div>
    </vx-card>

    <vx-card :title="`Лицевые счета | Всего ${totalAccounts}`" class="p-6">
      <vs-row class="mb-10">
        <vs-button
          :to="{ name: 'communal-payments-new-personal-account' }"
          color="primary"
          >Создать Лицевой счет</vs-button
        >
      </vs-row>
      <vs-table
        :data="accounts"
        :stripe="true"
        :search="false"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
      >
        <template slot="thead">
          <vs-th> Данные плательщика </vs-th>
          <vs-th> ЛС </vs-th>
          <vs-th> Баланс </vs-th>
          <vs-th> Действия </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p
                v-for="(home, index) in data[indextr].user.homes"
                :key="index"
                class="mb-2"
              >
                Поселок:
                <span class="text-primary">{{
                  home.county_type == "forest"
                    ? "Графский Лес"
                    : "Графские Пруды"
                }}</span
                >, участок
                <span class="text-primary">#{{ home.homestead_number }}</span>
              </p>
              <p class="mb-3">
                Житель:
                <span class="text-primary">{{
                  data[indextr].user.full_name
                }}</span>
              </p>
            </vs-td>

            <vs-td>
              {{ data[indextr].account }}
            </vs-td>

            <vs-td>
              {{ data[indextr].saldo }}
            </vs-td>

            <vs-td>
              <vx-tooltip class="inline-block" text="Открыть Лицевой счет">
                <vs-button
                  :href="`/communal-payments/personal-accounts/${data[indextr].id}`"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-eye"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-4"
        :total="totalPagePagination"
        v-model="currentPagingationPage"
      ></vs-pagination>
    </vx-card>
  </div>
</template>
<script>
import { API_URL, countItemsOmPage, countyType } from "@/.env";

export default {
  data: () => ({
    BASE_URL: API_URL,
    accounts: [],

    filter: {
      home__county_type: "",
      user__full_name: "",
      home__homestead_number: "",
      account__icontains: "",
    },
    countElements: 20,
    currentPagingationPage: 1,
    totalAccounts: 0,
    totalPagePagination: 1,
    countItemsOmPage,

    activeAddAccount: false,
    countyType,
  }),
  components: {},
  watch: {
    filter: {
      handler(val) {
        this.filterAccounts();
      },
      deep: true,
    },
    countElements: function () {
      this.currentPagingationPage = 1;
      this.getInvoices();
    },
    currentPagingationPage: function () {
      this.getInvoices();
    },
  },
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    filterAccounts: _.debounce(function () {
      this.currentPagingationPage = 1;
      this.getAccounts();
    }, 500),
    getAccounts() {
      this.$vs.loading();

      this.filter.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;
      this.filter.limit = this.countElements !== 20 ? this.countElements : 20;

      this.$load(async () => {
        let res = (await this.$api.personalAccounts.getAccounts(this.filter))
          .data;

        this.totalAccounts = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalAccounts / this.countElements
        );

        this.accounts = res.results;
        this.$vs.loading.close();
      });
    },
  },
  mounted() {
    this.getAccounts();
  },
};
</script>